import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES, ROUTE_TYPES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";
import {CompetitorRouteMetaDataModel} from "./competitor-route.meta-data.model";
import {CompetitorMatchModel} from "./competitor.match-model";

export class CompetitorRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor() {
    super();

    this.name = ROUTE_NAMES.competitor;
    this.path = `/:sportName/team/:key`;
    this.component = ReactLazyPreload(() => import("../components/competitor-container" /* webpackChunkName: "competitor-container" */ ));
    this.metadataType = CompetitorRouteMetaDataModel;
    this.matchType = CompetitorMatchModel;
    this.routeType = ROUTE_TYPES.main;
  }
}